import { FirebaseApp, FirebaseOptions, getApp, getApps, initializeApp } from "firebase/app"; //TODO @react-native-firebase/app';
import { Auth, connectAuthEmulator, getAuth, initializeAuth, onAuthStateChanged } from "firebase/auth"; // '@react-native-firebase/auth';
import { connectFunctionsEmulator, Functions, getFunctions } from "firebase/functions"; //'@react-native-firebase/functions';
import { connectStorageEmulator, getStorage, FirebaseStorage } from "firebase/storage";
import { Platform } from "react-native";
import AsyncStorage from "@react-native-async-storage/async-storage";

//to fix: ReferenceError: setImmediate is not defined
// https://github.com/software-mansion/react-native-reanimated/issues/4140
import "setimmediate";
import "react-native-reanimated";
import { getReactNativePersistence } from "@services/storage/reactNativeAsyncStorage";
import Constants from "expo-constants";
//import { setReactNativeAsyncStorage } from '@react-native-firebase/app';

export type FirebaseServices = {
  app: FirebaseApp;
  auth: Auth;
  functions: Functions;
  storage: FirebaseStorage;

  regionOrCustomUrl: string; // The prefix of the functions OR the domain
};

function connectEmulators(app: FirebaseApp, auth: Auth, functions: Functions, storage: FirebaseStorage) {
  console.warn("Connecting to emulators!");

  //JJ - When we deploy web we do not have all these environment variables - so instead we add them to the
  // Expo config in app.config.ts.
  // So we can use them here...
  const vars = Constants.expoConfig?.extra!;

  const authHost = vars.AUTH_EMULATOR_HOST!;
  console.warn("Auth emulator", authHost);
  // connectAuthEmulator(auth, authHost);
  connectAuthEmulator(auth, authHost);

  const functionHost = vars.FUNCTIONS_EMULATOR_HOST!;
  const url = new URL(functionHost);
  connectFunctionsEmulator(functions, url.hostname, Number(url.port));

  // We don't need firestore directly from the web - our functions use it!
  // const db = getFirestore();
  // connectFirestoreEmulator(db, 'localhost', 8080);

  const storageHost = vars.STORAGE_EMULATOR_HOST!;
  const storageUrl = new URL(storageHost);
  connectStorageEmulator(storage, storageUrl.hostname, Number(storageUrl.port));
}

function initFirebase() {
  // Before initializing Firebase set the Async Storage implementation
  // that will be used to persist user sessions.
  //setReactNativeAsyncStorage(AsyncStorage);

  //JJ - When we deploy web we do not have all these environment variables - so instead we add them to the
  // Expo config in app.config.ts.
  // So we can use them here...
  const vars = Constants.expoConfig?.extra!;

  // Initialize Firebase
  const firebaseConfig: FirebaseOptions = {
    apiKey: vars.API_KEY,
    authDomain: vars.AUTH_DOMAIN,
    databaseURL: vars.DATABASE_URL,
    projectId: vars.PROJECT_ID!,
    storageBucket: vars.STORAGE_BUCKET,
    messagingSenderId: vars.MESSAGING_SENDER_ID,
    appId: vars.APP_ID!,
    measurementId: vars.MEASUREMENT_ID,
  };

  // web requires dynamic initialization on web prior to using firebase
  // See: https://rnfirebase.io/#other--web
  // Android/iOS will use the google-services.json and GoogleService-Info.plist files.
  // JJ 22-Jun-2026 - WHY NOT initialise the same way
  // if (Platform.OS === "web") {
  console.info("Initialising firebase", firebaseConfig);
  const app = initializeApp(firebaseConfig);

  console.info("Initialising auth");
  // On web, use standard getAuth(app) so browser popup redirect resolver and browser persistence
  // are properly registered for Google/OAuth popups (prevents auth/argument-error).
  // On React Native (iOS/Android), use initializeAuth with AsyncStorage persistence.
  const auth =
    Platform.OS === "web"
      ? getAuth(app)
      : initializeAuth(app, {
          persistence: getReactNativePersistence(AsyncStorage),
        });

  onAuthStateChanged(auth, (user) => {
    console.debug("initFirebase - onAuthStateChanged", user);
  });

  console.info("Initialising functions");
  const functions = getFunctions(app);

  console.info("Initialising storage");
  const storage = getStorage(app);

  if (vars.env == "LOCAL") {
    connectEmulators(app, auth, functions, storage);
  }

  console.info("Initialised!");

  return { app, auth, functions, storage };
  // } else {
  //   console.info("Not initialising firebase for non-web platform");
  //   return { app: undefined, auth: undefined, functions: undefined, storage: undefined, regionOrCustomUrl: "" };
  // }
}

export function getFirebaseServices(): FirebaseServices {
  //JJ - When we deploy web we do not have all these environment variables - so instead we add them to the
  // Expo config in app.config.ts.
  // So we can use them here...
  const vars = Constants.expoConfig?.extra || {};

  if (getApps().length === 0) {
    initFirebase();
    console.info("Firebase initialized", getApps().length, vars?.FUNCTIONS_URL);
  }

  // ...now throughout your app, use firebase APIs normally, for example:
  const app = getApp();
  const auth = getAuth();
  const functions = getFunctions();
  const storage = getStorage();

  // TODO - where to set this region.....4
  // If we ever need to debug against a different backend...
  //const regionOrCustomUrl = "http://127.0.0.1:9003/memories-dev-247/europe-north1/api";
  const regionOrCustomUrl =
    vars?.FUNCTIONS_URL || process.env.EXPO_PUBLIC_FUNCTIONS_URL || "europe-north1";
  console.log("URL", regionOrCustomUrl);
  //const regionOrCustomUrl = "europe-north1";

  return { app, auth, functions, storage, regionOrCustomUrl };
}
